import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-drilldown",
    templateUrl: "./drilldown.component.html",
    styleUrls: ["./drilldown.component.scss"],
    standalone: false
})
export class DrilldownDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,

    public dialogRef: MatDialogRef<DrilldownDialogComponent>
  ) {
    if (data) {
      this.form = data.form;
      this.title = data.title;
      this.userOptions = data.userOptions;
      this.index = data.index;
    }
  }
  form!: any;
  userOptions!: any;
  title!: string;
  index!: number;

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {}
}
